export default __webpack_public_path__ + "static/media/CSS-logo.4bc4c158.svg";